var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [
      _vm._v(
        "You need to be logged into your account to access the book materials."
      )
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.signIn()
          }
        }
      },
      [
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label fw-bold",
              attrs: { for: "sign-in-email" }
            },
            [_vm._v("Email")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.email,
                expression: "loginData.email"
              }
            ],
            staticClass: "form-control",
            class: {
              invalid: _vm.errors && _vm.errors.email
            },
            attrs: { type: "text", id: "sign-in-email", required: "" },
            domProps: { value: _vm.loginData.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.loginData, "email", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.errors && _vm.errors.password
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(_vm._s(_vm.errors.email))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          _c(
            "label",
            {
              staticClass: "form-label fw-bold",
              attrs: { for: "sign-in-password" }
            },
            [_vm._v("Password")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.password,
                expression: "loginData.password"
              }
            ],
            staticClass: "form-control",
            class: {
              invalid: _vm.errors && _vm.errors.password
            },
            attrs: { type: "password", id: "sign-in-password", required: "" },
            domProps: { value: _vm.loginData.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.loginData, "password", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.errors && _vm.errors.password
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(_vm._s(_vm.errors.password))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3 text-center" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm._v("\n                Don't have an account? "),
            _c(
              "a",
              {
                staticClass: "fw-bold text-decoration-underline",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("showSignUpModal")
                  }
                }
              },
              [_vm._v("Register now!")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n            " + _vm._s(_vm.errors) + "\n        ")
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3 text-center" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "button",
          { staticClass: "btn dm-btn-padding", attrs: { type: "submit" } },
          [_vm._v("Log In")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }